import Axios from "axios";
import config from "./config";


export default class EspecialidadesService {
  static async getEspecialidades() {
    const urlEncodedDataPairs = [];
    urlEncodedDataPairs.push(
      encodeURIComponent("servico") + "=" + encodeURIComponent("getEspecialidades")
    );
    //const urlEncodedData = urlEncodedDataPairs.join("&").replace(/%20/g, "+");

    // fetch(config.API_URL_BASE, {
    //     method: "POST",
    //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //     body: urlEncodedData
    //   })
    //     .then(async (response) => {
    //       return await response.json()
    //     })
    //     .catch(e => console.log(e));

    // return Axios.post(config.API_URL_BASE, urlEncodedData,{headers:{
    //     "Content-Type": "multipart/form-data"
    // }})
    //     .then(response => {
    //          return response.data
    //     })
    //     .catch(err => {
    //        console.log(err)
    //      })

    const bodyFormData = new FormData();
    bodyFormData.append("servico", "getEspecialidades")
   // bodyFormData("servico", "getEspecialidades");
    
    let response = "";
    try {
      response = await Axios.post(config.API_URL_BASE, bodyFormData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    } catch (err) {
      return {status: false, error:err};
    }
    return response.data
  }
}
